/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-identifier-type.reducer';

export const PatientIdentifierTypeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientIdentifierTypeEntity = useAppSelector(state => state.patientIdentifierType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientIdentifierTypeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientIdentifierType.detail.title">PatientIdentifierType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierTypeEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.name">Name</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierTypeEntity.name}</dd>
          <dt>
            <span id="uuid">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.uuid">Uuid</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierTypeEntity.uuid}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.description">Description</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierTypeEntity.description}</dd>
          <dt>
            <span id="format">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.format">Format</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierTypeEntity.format}</dd>
          <dt>
            <span id="required">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.required">Required</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierTypeEntity.required ? 'true' : 'false'}</dd>
          <dt>
            <span id="formatDescription">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.formatDescription">Format Description</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierTypeEntity.formatDescription}</dd>
          <dt>
            <span id="validator">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.validator">Validator</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierTypeEntity.validator}</dd>
          <dt>
            <span id="locationBehavior">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.locationBehavior">Location Behavior</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierTypeEntity.locationBehavior}</dd>
          <dt>
            <span id="uniquenessBehavior">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.uniquenessBehavior">Uniqueness Behavior</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierTypeEntity.uniquenessBehavior}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierTypeEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierTypeEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierTypeEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierTypeEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierTypeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="prefix">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.prefix">Prefix</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierTypeEntity.prefix}</dd>
          <dt>
            <span id="postFix">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.postFix">Post Fix</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierTypeEntity.postFix}</dd>
          <dt>
            <span id="prefixYearSno">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierType.prefixYearSno">Prefix Year Sno</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierTypeEntity.prefixYearSno ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientIdentifierType.doctor">Doctor</Translate>
          </dt>
          <dd>{patientIdentifierTypeEntity.doctor ? patientIdentifierTypeEntity.doctor.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientIdentifierType.paramedic">Paramedic</Translate>
          </dt>
          <dd>{patientIdentifierTypeEntity.paramedic ? patientIdentifierTypeEntity.paramedic.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientIdentifierType.tenant">Tenant</Translate>
          </dt>
          <dd>{patientIdentifierTypeEntity.tenant ? patientIdentifierTypeEntity.tenant.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-identifier-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-identifier-type/${patientIdentifierTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientIdentifierTypeDetail;
